import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NOT_FOUND } from 'redux-first-router';

import {
  getLocationType,
  getLocationPayload,
  getLocationPrev,
  getLocationQuery,
} from '../reducers/location';

import store from '../store';

export const linkTo = (action) => {
  store.dispatch(action);
};

export const linkToRouteType = (type, payload) => {
  linkTo({
    type,
    payload,
  });
};

export const getRouteView = (locationType, views) => {
  if (!views[locationType]) {
    console.warn('routes/getRouteView()', 'invalid locationType', locationType);
    return views[NOT_FOUND];
  }

  return views[locationType];
};

const createRouteViews = views => (
  class RouteViews extends React.PureComponent {
    static propTypes = {
      locationType: PropTypes.string.isRequired,
      locationPayload: PropTypes.object.isRequired,
    };

    render() {
      const {
        locationType,
      } = this.props;

      const View = getRouteView(locationType, views);

      return (<View {...this.props} />);
    }
  }
);

const mapStateToProps = (state, ownProps) => ({
  locationType: getLocationType(state),
  locationPayload: getLocationPayload(state),
  locationQuery: getLocationQuery(state),
  locationPrev: getLocationPrev(state),
  ...ownProps,
});

export const createRoutes = views => connect(mapStateToProps)(createRouteViews(views));



// WEBPACK FOOTER //
// ./src/routes/helpers.js